import { ReactNode, useState } from "react";
import { Pressable } from "react-native";

import { BottomSheet } from "@/components/ui/bottom-sheet";

interface Props {
  children?: ReactNode;
  label: string;
  lat: number;
  lng: number;
  placeId?: null | string;
}

export default function OpenDirections({
  children,
  label,
  lat,
  lng,
  placeId,
}: Props) {
  const [open, setOpen] = useState(false);

  const encoded = encodeURIComponent(label);
  const appleMapsURL = `https://maps.apple.com/?daddr=${lat},${lng}&dname=${encoded}`;
  const googleMapsURL = placeId
    ? `https://www.google.com/maps/dir/?api=1&destination=${encoded}&destination_place_id=${placeId}`
    : `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

  function openUrl(url: string) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  function handlePress() {
    if (isSafari()) {
      setOpen(true);
    } else {
      openGoogle();
    }
  }

  function openApple() {
    openUrl(appleMapsURL);
    setOpen(false);
  }

  function openGoogle() {
    openUrl(googleMapsURL);
    setOpen(false);
  }

  return (
    <>
      <Pressable onPress={handlePress}>{children}</Pressable>

      <BottomSheet
        onClose={() => setOpen(false)}
        options={[
          { label: "open in apple maps", onPress: openApple },
          { label: "open in google maps", onPress: openGoogle },
        ]}
        visible={open}
      />
    </>
  );
}

function isSafari(): boolean {
  const ua = navigator.userAgent;
  return /Safari/.test(ua) && !/Chrome|CriOS|Chromium/.test(ua);
}
